export default "__VITE_ASSET__SnAK99ko__"